// Generated by ReScript, PLEASE EDIT WITH CARE


var targetOrigin = "*";

export {
  targetOrigin ,
}
/* No side effect */
